import { AxiosResponse } from "axios";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { IDeleteDataResponseAndPayload, TResponse, TResponseWithQData } from "../../../types/common";
import {
  IRecurringSchedule,
  IRecurringScheduleCreatePayload,
  IRecurringScheduleUpdatePayload,
  IRecurringScheduleRunNowResult,
} from "./types";

// ── Endpoints ────────────────────────────────────────────────────────────────
// These aren't in constants/api_endpoints.ts because that shared file was out
// of scope for this feature — kept local instead. Base path assumed to be
// `/recurring-schedules` under the existing `/company/v1` axios baseURL
// (config.apiUrl), matching the sibling `/jobs`, `/clients`, etc. modules.
// ASSUMPTION (flagged for reconciliation): exact mount path not independently
// verified against the backend repo — confirm `/recurring-schedules` is what
// the backend engineer actually mounted at `company/v1/index.ts`.
const BASE = "/recurring-schedules";

export const RECURRING_SCHEDULE_ENDPOINTS = {
  LIST: `${BASE}/list`,
  DETAIL: `${BASE}/detail`,
  CREATE: `${BASE}/create`,
  UPDATE: `${BASE}/update`,
  DELETE: `${BASE}/delete`,
};

export async function listRecurringSchedules(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IRecurringSchedule[]>>> {
  return axios.get(RECURRING_SCHEDULE_ENDPOINTS.LIST, { params: qData });
}

export async function recurringScheduleDetail(
  id: string | number
): Promise<AxiosResponse<TResponse<IRecurringSchedule>>> {
  return axios.get(`${RECURRING_SCHEDULE_ENDPOINTS.DETAIL}/${id}`);
}

export async function createRecurringSchedule(
  data: IRecurringScheduleCreatePayload
): Promise<AxiosResponse<TResponse<IRecurringSchedule>>> {
  return axios.post<TResponse<IRecurringSchedule>>(RECURRING_SCHEDULE_ENDPOINTS.CREATE, data);
}

export async function updateRecurringSchedule(
  data: IRecurringScheduleUpdatePayload
): Promise<AxiosResponse<TResponse<IRecurringSchedule>>> {
  const { id, ...rest } = data;
  return axios.put<TResponse<IRecurringSchedule>>(`${RECURRING_SCHEDULE_ENDPOINTS.UPDATE}/${id}`, rest);
}

export async function deleteRecurringSchedule(
  data: IDeleteDataResponseAndPayload
): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
  return axios.delete<TResponse<IDeleteDataResponseAndPayload>>(
    `${RECURRING_SCHEDULE_ENDPOINTS.DELETE}/${data.ids}`
  );
}

export async function toggleRecurringScheduleActive(
  id: string | number
): Promise<AxiosResponse<TResponse<IRecurringSchedule>>> {
  return axios.put<TResponse<IRecurringSchedule>>(`${BASE}/${id}/toggle-active`);
}

export async function runRecurringScheduleNow(
  id: string | number
): Promise<AxiosResponse<TResponse<IRecurringScheduleRunNowResult>>> {
  return axios.post<TResponse<IRecurringScheduleRunNowResult>>(`${BASE}/${id}/run-now`);
}
